"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),r=require("@vds/tiles"),t=require("styled-components"),i=require("@vds-tokens/core");function s(e){return e&&e.__esModule?e:{default:e}}const o=s(t).default.div.withConfig({displayName:"TileWrapper",componentId:"VDS__sc-1rcr2el-0"})`
  // remove after fixing focus indicator in vds
  [class*='OuterButton'] {
    overflow: visible;
  }
  [class*='OuterTileContainer'] {
    border-color: ${({theme:e})=>"monarch"===e&&`${i.ColorTokens.palette.warmgray84.value}!important`};
  }
  display: flex;
  /* height: 100%; */
  height: ${({height:e})=>e||void 0};
  width: 100%;
  > div > div:first-of-type {
    &:before {
      border-radius: ${({borderRadius:e})=>`${parseInt(e,10)+2}px`||"26px"} !important;
    }
  }
  > div > div:last-of-type {
    border-radius: ${({borderRadius:e})=>e||"24px"} !important;
  }
`;exports.default=t=>e.jsx(o,Object.assign({theme:t.theme,height:t.height,borderRadius:t.borderRadius,className:t.className,aspectRatio:t.aspectRatio},{children:e.jsx(r.TileContainer,Object.assign({},t))}));
